import { render, staticRenderFns } from "./Salir.vue?vue&type=template&id=5e4bef01&lang=pug&"
import script from "./Salir.vue?vue&type=script&lang=js&"
export * from "./Salir.vue?vue&type=script&lang=js&"
import style0 from "./Salir.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "Salir.vue"
export default component.exports